import React from 'react';
import BookingsTable from '@/features/dashboard/bookings/components/BookingsTable.tsx';

const BookingsPage = () => {
  return <BookingsTable />;
};

export default BookingsPage;
